export default [
    {
        path: '/inspectionHomePage',
        name: 'inspectionHome',
        component: () => import('@/views/inspection/inspectionHomePage.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/inspectiontitle',
        name: 'inspectiontitle',
        component: () => import('@/views/inspection/inspectinissue/inspectiontitle.vue'),
    },

    {
        path: '/reportPush',
        name: 'reportPush',
        component: () => import('@/views/inspection/reportPush/index.vue'),
    },

    {
        path: '/selectPushPerson',
        name: 'selectPushPerson',
        component: () => import('@/views/inspection/reportPush/selectPerson.vue'),
    },
    {
        path: '/selectEnterprisePerson',
        name: 'selectEnterprisePerson',
        component: () => import('@/views/inspection/reportPush/selectEnterprisePerson.vue'),
    },
]
